import React from 'react';

/**
 * React hook that persists any value between renders, but keeps it up-to-date if it changes.
 * @param fn the function to persist
 * @param deps the function dependency list
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const useCallbackRef = <T extends (...args: any[]) => any>(
  fn: T | undefined,
  deps: React.DependencyList = []
) => {
  const ref = React.useRef(fn);

  React.useLayoutEffect(() => {
    ref.current = fn;
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback(((...args) => ref.current?.(...args)) as T, deps);
};

export default useCallbackRef;
